/*
 * Governance Tile · shared Row primitive.
 *
 * Every metric row on E1, Judge, and Operator columns uses this shape:
 *   left  · optional glyph (✓ / ✗ / ◯) + label + optional tooltip trigger
 *   right · value badge (colour-coded via tone prop)
 *
 * Used by IJ-083 (E1), IJ-084 (Judge), IJ-085 (Operator).
 */

const TONE_CLASSES = {
  green: 'text-emerald-300 bg-emerald-500/10 border-emerald-500/30',
  amber: 'text-amber-300 bg-amber-500/10 border-amber-500/30',
  red: 'text-rose-300 bg-rose-500/10 border-rose-500/30',
  slate: 'text-slate-300 bg-slate-500/10 border-slate-500/30',
};

const GLYPH_COLOURS = {
  '✓': 'text-emerald-400',
  '✗': 'text-rose-400',
  '◯': 'text-slate-500',
};

export default function Row({ glyph, label, tooltip, value, tone = 'slate', testId, dense = false }) {
  return (
    <div
      data-testid={testId}
      className={
        'grid grid-cols-[1fr_auto] gap-x-3 items-baseline ' +
        (dense ? 'py-0.5 text-[11px]' : 'py-1.5 text-[13px]')
      }
    >
      <div className="text-slate-300 leading-snug">
        {glyph ? (
          <span className={'mr-1.5 ' + (GLYPH_COLOURS[glyph] || 'text-slate-400')}>{glyph}</span>
        ) : null}
        <span>{label}</span>
        {tooltip ? (
          <span
            title={tooltip}
            className="ml-1.5 inline-flex h-4 w-4 items-center justify-center rounded-full border border-slate-600 text-[9px] text-slate-400 cursor-help"
            aria-label="tooltip"
          >
            ?
          </span>
        ) : null}
      </div>
      {value ? (
        <span
          className={
            'px-2 py-0.5 rounded border text-[11px] font-medium tabular-nums whitespace-nowrap ' +
            (TONE_CLASSES[tone] || TONE_CLASSES.slate)
          }
        >
          {value}
        </span>
      ) : null}
    </div>
  );
}
